import { isPlatformServer } from '@angular/common';
import { ChangeDetectorRef, Component, HostBinding, inject, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '@common/layout/frontend-shared';
import { TrackingService } from '@common/tracking/frontend/tracking-consent/tracking.service';
import { AccessState, PageState } from '@core/frontend-shared';
import { fadeAnimation } from '@core/frontend-shared/utils/animations';
import { Store } from '@ngxs/store';

@Component({
    selector: 'pflegetheke-frontend-app',
    templateUrl: './app.component.html',
    styles: [
        ':host { display:block; height:100%; background:var(--backgroundColor); }',
        ':host(.wait-for-consent-setting) layout-contentbars-wrapper { filter:blur(2px); }',
        'layout-contentbar-top .right {display:flex;align-items:center; position:absolute;}',
    ],
    animations: [fadeAnimation],
    standalone: false
})
export class AppComponent {
	
	@HostBinding('class.wait-for-consent-setting')
	waitingForConsentDecision = false
	
	accessIsReady$ = inject(Store).select(AccessState.isReady) 
	loggedIn$ = inject(Store).select(AccessState.loggedIn) 
	isAdmin$ = inject(Store).select(AccessState.isAdmin) 
	pageTitle$ = inject(Store).select(PageState.title) 

	isSSR:boolean;

	constructor(
		public layout:LayoutService, 
		protected router:Router,
		protected tracking:TrackingService,
		protected cd:ChangeDetectorRef,
		@Inject(PLATFORM_ID) private ngPlatformId,
	) { 
		this.isSSR = isPlatformServer(ngPlatformId);
		if(!this.isSSR) {
			tracking.consentState.subscribe(state=>{
				const waitingForConsentDecision = state === null;
				this.waitingForConsentDecision = waitingForConsentDecision;
				this.cd.markForCheck();
			});
		}
	}

}
